import React from "react";
import { Button } from "./Button";

export function EmptyState({ icon: Icon, title, description, actionLabel, onAction, actionTo, className = "" }) {
  return (
    <div className={`border border-dashed border-white/10 rounded-2xl px-8 py-16 text-center ${className}`}>
      {Icon && (
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-white/[0.03] border border-white/5 mb-6">
          <Icon className="w-6 h-6 text-zinc-600" strokeWidth={1.5} />
        </div>
      )}
      {title && <h3 className="font-display text-xl text-white mb-2">{title}</h3>}
      {description && (
        <p className="text-sm text-zinc-500 max-w-md mx-auto leading-relaxed">{description}</p>
      )}
      {actionLabel && (onAction || actionTo) && (
        <div className="mt-8">
          {actionTo ? (
            <Button as="a" href={actionTo} variant="primary" size="lg">
              {actionLabel}
            </Button>
          ) : (
            <Button variant="primary" size="lg" onClick={onAction}>
              {actionLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export default EmptyState;
